import { Days } from '../dates/days.enum';

export const DAYS_LIST = [
  Days.monday,
  Days.tuesday,
  Days.wednesday,
  Days.thursday,
  Days.friday,
  Days.saturday,
  Days.sunday,
];
